const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;

export function validateHyperwolfBrand(data) {
  const errors = {};

  if (!data.brandName?.trim()) {
    errors.brandName = 'Brand name is required';
  } else if (data.brandName.length > 100) {
    errors.brandName = 'Brand name should be at most 100 characters';
  }

  if (data.salesRepresentativeEmail?.trim()) {
    if (data.salesRepresentativeEmail.length > 100) {
      errors.salesRepresentativeEmail = 'Email should be at most 100 characters';
    } else if (!emailRegex.test(data.salesRepresentativeEmail)) {
      errors.salesRepresentativeEmail = 'Please enter a valid email address';
    }
  }

  if (data.billingEmail?.trim()) {
    if (data.billingEmail.length > 100) {
      errors.billingEmail = 'Email should be at most 100 characters';
    } else if (!emailRegex.test(data.billingEmail)) {
      errors.billingEmail = 'Please enter a valid email address';
    }
  }

  if (data.salesRepresentativePhone?.trim()) {
    const digitsOnly = String(data.salesRepresentativePhone).replace(/\D/g, '');
    if (digitsOnly.length !== 10) {
      errors.salesRepresentativePhone = 'Please enter a valid 10-digit phone number';
    }
  }

  if (data.websiteUrl?.trim()) {
    if (data.websiteUrl.length > 500 ) {
      errors.websiteUrl = 'Website URL should be at most 500 characters';
    } else if (!urlRegex.test(data.websiteUrl)) {
      errors.websiteUrl = 'Please enter a valid URL';
    }
  }

  const isValid = Object.keys(errors).length === 0;
  return { isValid, errors };
}

export function validateMainBrand(brandData) {
    const {
        title,
        metaTitle,
        metaDescription,
        description,
        image,
        isStilo
    } = brandData;

    const errors = {};

    if (!metaDescription || metaDescription.trim() === '') {
        errors.metaDescription = 'Meta description is required.';
    }
    if (!metaTitle || metaTitle.trim() === '') {
        errors.metaTitle = 'Meta title is required.';
    }
    if (!title || title.trim() === '') {
        errors.title = 'Title is required.';
    }

    if (!description || description.trim() === '') {
        errors.description = 'Description is required.';
    }

    if ((!image || typeof image !== 'string' || image.trim() === '' )&&!isStilo) {
          errors.image = 'Image URL is required and should be a non-empty string.';
    }
    // Check if there are any errors
    const isValid = Object.keys(errors).length === 0;

    // Return an object with isValid and errors
    return {
        isValid,
        errors,
    };
}